"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeaturesListItem = FeaturesListItem;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
var _index2 = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _price = _interopRequireDefault(require("@site/pattern-library-core/price"));
var _image = require("@site/pattern-library-core/image");
var _merchButton = require("@site/pattern-library-core/merch-button");
var _index3 = _interopRequireDefault(require("../../../elements/buttons/add-to-cart/index.js"));
var _headerCartButton = _interopRequireDefault(require("../../../experiments/header-cart-button"));
var _index4 = _interopRequireDefault(require("../../../elements/buttons/link/index.js"));
var _text = _interopRequireDefault(require("@ux/text"));
/* eslint-disable complexity */

/**
 * Local Imports
 */

const CardWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardWrapper",
  class: "pl-c1g8o1jl",
  vars: {
    "c1g8o1jl-4": [({
      col
    }) => col]
  }
});
const Flag = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Flag",
  class: "pl-fvj822g"
});
const planTagTextStyles = "pl-p156kjwq";
const PlanType = /*#__PURE__*/(0, _react2.styled)(_index.default)({
  name: "PlanType",
  class: "pl-p12rvo8q"
});
const Description = /*#__PURE__*/(0, _react2.styled)(_paragraph.default)({
  name: "Description",
  class: "pl-d1rtk7ey"
});
const CTAContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CTAContainer",
  class: "pl-c5i7vtr"
});
const ListContainer = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "ListContainer",
  class: "pl-lq7ou2s"
});
const ListItem = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "ListItem",
  class: "pl-lcjylwm"
});
const Item = /*#__PURE__*/(0, _react2.styled)(_paragraph.default)({
  name: "Item",
  class: "pl-i1vuogpe"
});
const IconWrapper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "IconWrapper",
  class: "pl-i13b7jr1"
});
const CrossLinkContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CrossLinkContainer",
  class: "pl-clj6chm"
});

/**
 * FeaturesListItem Mapper.
 *
 * @param {Object} props React props
 * @param {Array} props.features List Item Icon Array
 * @param {String} props.iconColor List Item Icon Color
 * @returns {React.ReactElement} FeaturesListItem Mapper
 * @public
 */

function FeaturesListItem({
  features,
  iconColor = '#111111'
}) {
  if (!features) return null;
  return /*#__PURE__*/_react.default.createElement(ListContainer, null, features.map(({
    text: textProp,
    tooltip
  }, i) => /*#__PURE__*/_react.default.createElement(ListItem, {
    key: i
  }, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "checkmark",
    width: "18",
    height: "18",
    fill: iconColor
  })), /*#__PURE__*/_react.default.createElement(Item, {
    text: textProp,
    tooltip: tooltip,
    className: "ux-text ux-text-paragraph ux-text-size-1"
  }))));
}
FeaturesListItem.propTypes = {
  features: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.node
  })),
  iconColor: _propTypes.default.string
};

/**
 * SubscriptionItem Component.
 * @module PlanBoxSubscriptionItem
 *
 *  * The PlanBoxSubscriptionItem uses the following local intents to style the Highlighted Item:
 * Flag Colors:
 * - intents.ux.box.borderColor - highlight-primary partial
 * - intents.ux.box.foregroundColor
 * Plan Box Background:
 * - intents.ux.box.backgroundColor data-partial='highlight-primary'
 * - intents.ux.box.foregroundColor
 * You can add the above intents to your theme if you want to have more control over the styling of the
 * highlighted Plan Box.
 *
 * @param {Object} props React props
 * @param {String} props.id The id of the content item
 * @param {Number} props.col Grid column
 * @param {Boolean} props.flag Flag Active State
 * @param {String} props.flagText Flag Text
 * @param {String} props.planTagText As low as Top Text
 * @param {String} props.planType PlanType Headline
 * @param {String} props.description Plan Description
 * @param {Object} props.cta Plan Button
 * @param {Object} props.featuresList Plan Compare Items Object
 * @param {Object} props.crossLink Cross Link Button Object
 * @param {String} props.crossLinkDisclaimer Cross Link Disclaimer
 * @param {Object} props.featuresList Plan Compare Items Object
 * @param {Boolean} props.showImageWrapper Show image wrapper
 * @param {Object} props.image Image Object
 * @returns {React.ReactElement} SubscriptionItem Component
 * @public
 */

function SubscriptionItem({
  id,
  col,
  flag,
  flagText,
  planTagText,
  planType,
  description,
  cta = {},
  featuresList,
  crossLink,
  crossLinkDisclaimer,
  showImageWrapper,
  image,
  price
}) {
  const {
    ctaRef
  } = (0, _patternLibraryUtils.useTrackingUpdate)(cta);
  const buttonSetSupportedTemplateMap = {
    addToCart: _index3.default,
    HeaderCartButton: _headerCartButton.default,
    Link: _index4.default
  };
  return /*#__PURE__*/_react.default.createElement(CardWrapper, {
    id: `id-${id}`,
    col: col,
    "data-cy": "subscription-item",
    "data-flag": !!flag,
    "data-partial": "highlight-primary"
  }, flag && /*#__PURE__*/_react.default.createElement(Flag, {
    "data-cy": "flag"
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    text: flagText
  })), (showImageWrapper || image) && /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "plan-box-subscription-img-wrapper"
  }, image?.url && /*#__PURE__*/_react.default.createElement(_image.LazyPicture, {
    defaultSrc: image.url,
    defaultAltText: image?.altText,
    width: image?.width,
    height: image?.height
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "plan-type"
  }, planTagText && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -1,
    className: planTagTextStyles,
    text: planTagText
  }), /*#__PURE__*/_react.default.createElement(PlanType, {
    heading: planType,
    headlineTag: "h3",
    headlineSize: "h6",
    headlineLineLength: 3.0,
    textAlign: "start"
  })), /*#__PURE__*/_react.default.createElement(Description, {
    text: description
  }), price && /*#__PURE__*/_react.default.createElement(_price.default, (0, _extends2.default)({}, price, {
    headlineSize: "h3"
  })), cta && /*#__PURE__*/_react.default.createElement(CTAContainer, {
    "data-cy": "subscription-item-cta",
    className: "cta",
    ref: ctaRef
  }, /*#__PURE__*/_react.default.createElement(_index2.default, {
    actionsLayout: "button-set",
    ctas: [{
      ...cta,
      width: 'full'
    }]
  })), featuresList && /*#__PURE__*/_react.default.createElement(FeaturesListItem, featuresList), (crossLink || crossLinkDisclaimer) && /*#__PURE__*/_react.default.createElement(CrossLinkContainer, {
    "data-cy": "cross-links"
  }, /*#__PURE__*/_react.default.createElement("div", null, crossLink && /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
    templateMap: buttonSetSupportedTemplateMap,
    buttons: [{
      ...crossLink,
      width: 'full',
      templateName: 'Link',
      design: 'inline'
    }]
  }), crossLinkDisclaimer && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": "cross-link-disclaimer",
    text: crossLinkDisclaimer,
    className: "disclaimer"
  }))));
}
var _default = exports.default = SubscriptionItem;
SubscriptionItem.propTypes = {
  id: _propTypes.default.string,
  col: _propTypes.default.number,
  flag: _propTypes.default.bool,
  flagText: _propTypes.default.string,
  planTagText: _propTypes.default.string,
  planType: _propTypes.default.string,
  description: _propTypes.default.string,
  cta: _propTypes.default.object,
  featuresList: _propTypes.default.shape({
    features: _propTypes.default.array,
    iconColor: _propTypes.default.string
  }),
  crossLink: _propTypes.default.object,
  crossLinkDisclaimer: _propTypes.default.string,
  showImageWrapper: _propTypes.default.bool,
  image: _propTypes.default.object,
  price: _propTypes.default.shape(_price.default.propTypes)
};